<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000"
    v-if="pairing"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Active Tru-Point Pairing
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="onCloseClick()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div>Vendor: <b>{{pairing.vendor}}</b></div>
        <div>Vendor Key: <b>{{pairing.vendorKey}}</b></div>
        <div>Alignment ID: <b>{{pairing.alignmentId}}</b></div>
        <div>Tru-Point Serial Number: <b>{{pairing.truPointSerialNumber}}</b></div>
        <div>Updated At: <b>{{formatTime(pairing.updatedAt)}}</b></div>
        <v-card flat style="overflow-y: auto; height: 300px; background-color: #F5F5F5;">
          <Calibration
            v-for="(item, index) in pairing.calibrations"
            :name="item.name"
            :state="item.state"
            :passed="item.passed"
            :reportMessage="item.reportMessage"
            :key="index"
          >
          </Calibration>
          <div
            v-if="pairing.calibrations && pairing.calibrations.length === 0"
            class="pa-3"
            style="background-color: black; color: white; text-align: center;"
          >
            NO CALIBRATIONS
          </div>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="grey lighten-1"
          @click="onCloseClick()"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import Calibration from './Calibration.vue';

export default {
  components: {
    Calibration,
  },

  props: {
    dialog: Boolean,
    pairing: Object,
  },

  data() {
    return {
    };
  },

  methods: {
    onCloseClick() {
      this.$emit('close');
    },
    formatTime(time) {
      return moment(time).local().format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
